import { render, staticRenderFns } from "./CarrinhaEmpresaFinalizarDetalhesPagamentoPrazos.vue?vue&type=template&id=04af3d2a&scoped=true"
import script from "./CarrinhaEmpresaFinalizarDetalhesPagamentoPrazos.vue?vue&type=script&lang=js"
export * from "./CarrinhaEmpresaFinalizarDetalhesPagamentoPrazos.vue?vue&type=script&lang=js"
import style0 from "./CarrinhaEmpresaFinalizarDetalhesPagamentoPrazos.vue?vue&type=style&index=0&id=04af3d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04af3d2a",
  null
  
)

export default component.exports